import React, { useEffect, useRef, useState } from 'react'
import Modal from '../../../../Modal/Modal';
import { useSelector } from 'react-redux';
import CreateAccessRestrictionUI from './CreateAccessRestrictionUI';

const CreateAccessRestriction = ({fetchAutomations}) => {

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);

        const apiData = {
            token,
            client
        }
    
        const [modalComponent, setModalComponent] = useState(null);
        const [modalPageIndex, setModalPageIndex] = useState(0);
    
        //------------------------------- Modal Logic  ----------------------------------------------
    
        const ModalDialog = useRef();
    
        // call ref to clearStates method from child component ScheduledAction.
        const ClearStatesChildComponetRef = useRef();
    
        const HandleShowModal = () => {
            ModalDialog.current.open();
        }
    
        const HandleCloseModal = () => {
            ModalDialog.current.close();
    
            //reset states for scheduled Action
            if (ClearStatesChildComponetRef.current && ClearStatesChildComponetRef.current.HandleResetAllStates) {
                // Call the child method
                ClearStatesChildComponetRef.current.HandleResetAllStates();
            }
    
        }
        //-------------------------------------------------------------------------------------------------
    
        // reset model when Escape key is pressed
        useEffect(() => {
            const handleKeyDown = (event) => {
                if (event.key === 'Escape') {
                    // Handle the Escape key press here
                    setModalPageIndex(null);
                }
            };
    
            // Add event listener when component mounts
            document.addEventListener('keydown', handleKeyDown);
    
    
            // Clean up event listener when component unmounts
            return () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        }, []);

        useEffect(() => {
            switch (modalPageIndex) {
                case 0:
                    setModalComponent(<CreateAccessRestrictionUI HandleCloseModal={HandleCloseModal} fetchAutomations={fetchAutomations}/>)
                    HandleShowModal();
                    break;
            }
        }, [modalPageIndex]); 
    
    return (
        <>
            <Modal ref={ModalDialog} title={"Set access restrictions"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "700px", minHeight: "420.5px" }} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>
        </>
    )
}

export default CreateAccessRestriction;